<template>
    <section class="catalog">
        <div class="row" :class="{'d-flex justify-content-center': catalogStore.mobileSearch}">
            <div class="col-12 col-md-4 col-lg-3 pt-4 pt-md-0 position-relative" :class="{'d-none d-md-block': !catalogStore.mobileSearch}">
                <button type="button" class="d-block d-md-none btn-close position-absolute top-0 end-0 mt-4 me-2" @click="catalogStore.toggleMobileSearch" aria-label="Close" style="z-index: 1000;"></button>
                <CatalogFilters :weight-range="catalog.weight_range" @filter-applied="search"/>
            </div>
            <div class="col-12 col-md-8 col-lg-9">
                <CatalogProducts @search="search" @export-pdf="exportToPdf"/>
            </div>
        </div>
    </section>
</template>

<script setup>
const catalogStore = useCatalogStore();

const catalog = computed(() => catalogStore.catalog);

const route = useRoute();
const router = useRouter();

const search = (opts) => {
    const params = getParamsForRequest();
    catalogStore.catalogResource.filters_selected = params;
    catalogStore.fetchCatalog(params.term, opts);
}

const getParamsForRequest = () => {
    return {
        url: route.path,
        update_filters: true,
        ...catalogStore.filtersSelected,
        term: route.query.term || '',
        page: catalogStore.paginator.current_page,
    };
};

const exportToPdf = () => {
    let params = getParamsForRequest();

    let formattedParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
            value.forEach(item => {
                formattedParams.append(`${key}[]`, item);
            });
        } else {
            formattedParams.append(key, value);
        }
    }

    window.open('/api/client/catalog/pdf/?t=' + new Date().getTime() + '&' + formattedParams.toString(), '_blank');
}
</script>
